import 'normalize.css'
import { createApp } from 'vue'
import { createStore } from 'vuex'
import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'
import App from './App.vue'
import Home from './components/Home.vue'
import SingleEvent from './components/SingleEvent.vue'
import FavoriteEvents from './components/FavoriteEvents.vue'
import './registerServiceWorker'
import gsap from 'gsap';
import VueGtag from 'vue-gtag';
// import VueAddtohomescreen from '@owliehq/vue-addtohomescreen';
//import {Power4} from 'gsap';

const router = createRouter({
    history: createWebHistory(),
    mode: 'history',
    routes: [
        {name: 'home', path: '/', component: Home},
        {name: 'fav', path: '/favoris', component: FavoriteEvents},
        {name: 'single-event', path: '/:eventId', component: SingleEvent}
    ]
});

const store = createStore({
    state(){
        return {
            // dataUrl: 'https://osr-app-2a8b6-default-rtdb.europe-west1.firebasedatabase.app/events.json',
            // dataUrl: 'http://localhost:3000/events',
            dataUrl: 'https://osr-osr20ma32.ideative.io/fr/?json',
            connectionStatus: '',
            currentPage: 'Concerts',
            currentFilter: 'all',
            events: [],
            filteredEvents: [],
            // serieType: [],
            favorites: [],
            isLoading: true,
            featuredEvent: ''
        };
    },
    // getters: {
    //     fullListOfEvents: state => {
    //       return state.events;
    //     }
    // },
    // getters: {
    //     isOnline: function () {
    //         if(navigator.onLine){
    //           return true;
    //         } else {
    //           return false;
    //         }
    //     }
    // },
    mutations: {
        toggleToFavorites(state, payload){
            //console.log('togglew to fav from MAIN js');
            if(state.favorites.includes(payload.concert)){
                const index = state.favorites.indexOf(payload.concert);
                state.favorites.splice(index, 1);

                console.log(router.currentRoute.value.name)
                console.log(state.favorites.length)

                if(router.currentRoute.value.name == 'fav' && state.favorites.length < 1){
                    router.push({path: '/'})
                }
                    
            } else {
                state.favorites.push(payload.concert);
            }
            localStorage.setItem('favEvents', JSON.stringify(state.favorites));


        },
        checkConnectionStatus(state) {	
            if (navigator.onLine){
                state.connectionStatus = 'online';
            } else{
                state.connectionStatus = 'offline';
            }
        },
        setData(state, payload){
            state.events.length = 0;
            state.events.push(... payload.data.data.events);

            state.filteredEvents.lenght = 0;
            state.filteredEvents.push(... state.events);

            state.featuredEvent = state.events[0];

            localStorage.setItem('osrEvents', JSON.stringify(payload.data.data.events));


            //window.addeventatc.refresh();
            // let externalScript = document.createElement('script')
            // externalScript.setAttribute('src', 'https://addevent.com/libs/atc/1.6.1/atc.min.js')
            // document.body.appendChild(externalScript)
            state.isLoading = false;
        },
        filteringEvents(state, payload){

            state.isLoading = true
            
            setTimeout(function(){
                state.currentFilter = payload.filter;
                state.filteredEvents.length = 0;
                if(payload.filter === 'all'){
                    state.filteredEvents.push(... state.events);
                } else {
                    const filteredList = state.events.filter((event) => event.month === payload.filter);
                    state.filteredEvents.push(... filteredList);
                }
                state.isLoading = false
            }, 100);



        },
    },
    actions: {
        getAndSetData(context){
            // context.state.commit('setData');
            if(context.state.connectionStatus === 'online'){ // if internet connection, fetch data from porvided API URL
                axios.get(context.state.dataUrl)
                .then(response => {
                  context.commit('setData', {
                      data: response
                  });

                })
                .catch(function (error) {
                  // handle error
                  console.log(error);
                })
                .then(function () {
                  // always executed
                });
            } else { // Otherwise check if there is a cached version of that data in the localStorage
              const localData = JSON.parse(localStorage.getItem('osrEvents'));
              context.state.events.length = 0;
              context.state.events.push(... localData);
              context.state.filteredEvents.lenght = 0;
              context.state.filteredEvents.push(... localData);
              context.state.isLoading = false;
            }

            if(localStorage.getItem('favEvents')) {
                context.state.favorites = JSON.parse(localStorage.getItem('favEvents'));
			}

            
        },
    }
});

const app = createApp(App);

app.use(store);
app.use(router);
//app.use(VueOnlineProp);
app.use(VueGtag, {
    appName: 'OSR APP',
    pageTrackerScreenviewEnabled: true,
    config: { id: 'G-C8B93803K7' }
}, router);
// app.use(VueAddtohomescreen);

router.isReady().then(function(){
    app.mount('#app');
});

router.afterEach((to, from, next) => {
    // console.log('TO : ', to)
    // console.log('FROM : ', from);
    console.log('BEFORE EACH TRIGGERED')
    gsap.to('.current-page-name', .5, {y: '50%', autoAlpha: 0, onComplete: function(){
        if(to.name === 'single-event'){
            //console.log('single-event')
            //console.log(to.params.eventId)
            const event = store.state.events.find(event => event.id == to.params.eventId)
            // console.log('sdfsdfsdfsdf ' + event.title);
            //console.log(event.title.length)
            //const eventTitle = event.title.length > 20 ? event.title.substring(0, 20) + '...' : event.title;
            store.state.currentPage = event.title;
        } else if(to.name === 'fav') {
            store.state.currentPage = 'Favoris'
        } else {
            store.state.currentPage = 'Concerts'
        }
        gsap.to('.current-page-name', .5, {y: 0, autoAlpha: 1})
    }});
    next();
    
});

// router.beforeRouteUpdate(()=>{
//     console.log('Before Route Enter')
//     if(window.addeventatc != undefined){
//         window.addeventatc.refresh();
//     }
    
// })


